export function formatSharePointConnectError(detail: string): string {
  if (
    detail.includes("AADSTS50194") ||
    detail.includes("/common endpoint") ||
    detail.includes("not configured as a multi-tenant")
  ) {
    return "SharePoint sign-in failed. Check Nango OAuth URLs use your tenant, not /common/.";
  }
  return detail;
}
